import './Paper.scss'

function Paper({ children }) {
    return (
        <div className="paper">
            {children}
        </div>
    )
}

export default Paper